import { FC } from 'react';

import styled from 'styled-components';

import InfoModal from '@components/ui/modals/InfoModal';

export const StyledInfoModal = styled(InfoModal)`
  max-width: 600px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100vw !important;
    position: fixed;
    top: 0;
    left: 0;
  }
`;

export const Text = styled.span<{
  bold?: boolean;
  size?: number;
  opacity?: number;
}>`
  font-size: ${({ size }) => size || 20}px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: ${({ opacity }) => opacity};
`;

interface Props {
  title: string;
  description: string | React.ReactNode;
  onCancel?: () => void;
}

const ErrorInfoModal: FC<Props> = ({ title, description, onCancel }) => {
  return (
    <StyledInfoModal
      title={
        <Text size={25} bold>
          {title}
        </Text>
      }
      content={<span>{description}</span>}
      onCancel={onCancel}
    />
  );
};

export default ErrorInfoModal;
